import { useEffect } from 'react';
import { useAuth, useOrganization } from '@clerk/clerk-react';
import { setAuthTokenGetter, setOrgIdGetter } from './api';

// Call this hook once at the top of your app to wire Clerk token + org into axios
export function useApiAuth() {
  const { getToken } = useAuth();
  const { organization } = useOrganization();

  useEffect(() => {
    setAuthTokenGetter(getToken);
  }, [getToken]);

  useEffect(() => {
    setOrgIdGetter(() => organization?.id || null);
  }, [organization]);
}
